/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api; bearer: string; };
type HookTuple = [
  response: vp.TransactionsRefundResponse,
  TransactionRefund: (params: vp.TransactionsRefundRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostTransactionRefund: ApiHook = ({ api, bearer }) => {
  const [shouldTransactionRefund, setShouldTransactionRefund] = useState(false);
  const source = axios.CancelToken.source();
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  const [params, setParams] = useState<vp.TransactionsRefundRequest>({
    TransactionID: '',
  });
  const [response, setResponse] = useState<vp.TransactionsRefundResponse>({
    Success: false,
    ErrorMessage: '',
    TransactionID: '',
  });

  useEffect(() => {
    if (!shouldTransactionRefund) return () => {};

    const TransactionRefund = async () => {
      setDataFetchingInfo(true, 'setting as default..', 'fullScreen');
      const res = await api.postTransactionRefund(params, bearer, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldTransactionRefund) void TransactionRefund();
    setShouldTransactionRefund(false);
    return () => {
      source.cancel();
    };
  }, [shouldTransactionRefund]);

  return [
    response,
    (_params: vp.TransactionsRefundRequest) => {
      setParams(_params);
      setShouldTransactionRefund(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        TransactionID: '',
      });
      setShouldTransactionRefund(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostTransactionRefund);
